import { Button, Input } from '@fluentui/react-components';
import type { OfferLine } from '../../../models/Offer';
import { DataTable } from '../../common/DataTable';

export const OfferLines = ({ lines, onUpdate, onRemove }: { lines: OfferLine[]; onUpdate: (lineId: string, patch: Partial<OfferLine>) => void; onRemove: (lineId: string) => void }) => (
  <DataTable
    items={lines}
    columns={[
      { columnId: 'product', label: 'Product', renderCell: (item) => item.cr_crm_productname ?? item.cr_crm_skuname },
      { columnId: 'quantity', label: 'Quantity', renderCell: (item) => <Input type="number" style={{ width: 80 }} value={String(item.cr_crm_quantity)} onChange={(_, data) => onUpdate(item.cr_crm_offerlineid, { cr_crm_quantity: Number(data.value) })} /> },
      { columnId: 'price', label: 'Unit USD', renderCell: (item) => <Input type="number" style={{ width: 100 }} value={String(item.cr_crm_unitpriceusd)} onChange={(_, data) => onUpdate(item.cr_crm_offerlineid, { cr_crm_unitpriceusd: Number(data.value) })} /> },
      { columnId: 'discount', label: 'Discount %', renderCell: (item) => <Input type="number" style={{ width: 70 }} value={String(item.cr_crm_discountpct)} onChange={(_, data) => onUpdate(item.cr_crm_offerlineid, { cr_crm_discountpct: Number(data.value) })} /> },
      { columnId: 'actions', label: 'Actions', renderCell: (item) => <Button appearance="subtle" style={{ marginLeft: 8 }} onClick={() => onRemove(item.cr_crm_offerlineid)}>Remove</Button> },
    ]}
    getRowId={(item) => item.cr_crm_offerlineid}
    emptyMessage="No product line yet."
  />
);
